import { getCustomFormConfig } from '../../../dateneingabe/co2_custom/getCustomFormConfig';
import { IDs } from '../../../../helpers/IDs';
import { isValid } from '../../../../main/functions/validData';
import { StructureService } from '../../../../services/structure_service';

export class Table {

    protected curEntity: string = null;
    protected curItem: any = {};
    protected curStructure: any = {};
    protected readonly dataEntities: any;
    protected readonly filter: any;

    constructor(data: any, filter: any = {}) {
        this.dataEntities = data || {};
        this.filter = filter || {};
    }

    public getStructure(): any {
        return this.curStructure;
    }

    public getUnit(key?: string): string {
        switch (this.curEntity) {
            case IDs.ENT_CO2_SCOPE3_ABFALL:
                if (typeof this.curItem.co2_absolut !== 'undefined') {
                    return 'kg'
                } else if (typeof this.curItem.menge !== 'undefined') {
                    return 'kg'
                } else if (typeof this.curItem.volumen_tonne !== 'undefined') {
                    return 'Liter'
                }
                return null;
            default:
                return null;
        }
    }

    public getValue(key: string): any {
        return this.transformValue(key);
    }

    public processData(entity: string, filter: any, callback: (data: any) => void): void {
        if (entity && typeof callback === 'function') {
            filter = filter || {};
            this.curEntity = entity;
            this.setStructure(entity);

            (this.dataEntities[entity] || []).forEach((item: any) => {
                const filterJahr: boolean = filter.jahr !== null && this.filter.jahr;
                const filterStandort: boolean = filter.standort_tid !== null && this.filter.standort_tid;
                this.setItem(item);

                if (
                    (!filterStandort || (this.curItem.standort_tid_orig || this.curItem.standort_tid) === this.filter.standort_tid)
                    && (!filterJahr || this.curItem.jahr === this.filter.jahr)
                    && isValid(this.curItem, entity, this.dataEntities[entity])
                ) {
                    callback(this.curItem);
                }
            });
        }
    }

    protected setItem(item: any): any {
        if (!item.tid) {
            return item;
        }
        this.curItem = { ...item };
        const status: any = getCustomFormConfig(this.curEntity, item, this.dataEntities) || {};

        Object.keys(status).forEach((key: string) => {
            if ((status[key].hidden || status[key].hidden_input) && ['jahr', 'standort_tid'].indexOf(key) === -1) {
                delete this.curItem[key];
            }
        });
    }

    protected setStructure(entity: string): any {
        this.curStructure = (((StructureService || {}).structures || {})[IDs.MOD_ETOOL] || {})[entity] || {};
    }

    protected transformValue(key: string): any {
        const atts: any[] = this.curStructure.ATTS || [];
        const field: any = atts.find((item: any) => item.KEY === key) || {};
        const opts: any = field.OPTS || null;
        let value: any = this.curItem[key];

        if (Array.isArray(opts)) {
            value = (opts.find((opt: any) => opt.VALUE == this.curItem[key]) || {}).TITEL || '';
        }

        return value;
    }
}
